import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-multi-login',
  templateUrl: './multi-login.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiLoginComponent {
  constructor(public activeModal: NgbActiveModal) {}

  close() {
    this.activeModal.close('close');
  }

  keep() {
    this.activeModal.close('keep');
  }
}
